import { useQuery } from '@apollo/client'
import { Order } from '@interflora/ui-components/build/common/props'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import OrderHistoryGallery from '@interflora/ui-components/build/components/OrderHistory/OrderHistory'
import React, { useContext, useEffect, useState } from 'react'
import { GET_HISTORIC_ORDERS } from '../../graphql/queries'
import AnalyticsContext from 'context/AnalyticsContext'

type OrdersResponse = {
  orders: Order[]
  isLastPage: boolean
}
const orderHistoryInitialValues = { orders: [], isLastPage: true }
const OrderHistory = () => {
  const { getCustomer } = useContext(SiteContext)
  const [orders, setOrders] = useState<OrdersResponse>(orderHistoryInitialValues)
  const [page, setPage] = useState(1)
  const analytics = useContext(AnalyticsContext)

  const farEyeTrackOrderAnalytics = (url?: string) => {
    analytics.farEyeTrackOrder(url)
  }
  const { loading, refetch } = useQuery(GET_HISTORIC_ORDERS, {
    variables: { input: { page } },
    onCompleted: (data) => {
      let ordersList = orders?.orders.concat(data.historicOrders.orders)
      if (orders?.orders?.length > 0 && page === 1) ordersList = orders?.orders
      setOrders({
        orders: ordersList,
        isLastPage: data.historicOrders.isLastPage,
      })
    },
  })

  useEffect(() => {
    refetch()
  }, [page, refetch])

  return getCustomer.loading || !getCustomer.data?.customer || (loading && !orders?.orders?.length) ? (
    <h1>Loading</h1>
  ) : (
    <OrderHistoryGallery
      orders={orders?.orders}
      setPage={setPage}
      page={page}
      isLastPage={orders?.isLastPage}
      isLoading={loading}
      farEyeTrackOrderAnalytics={farEyeTrackOrderAnalytics}
    />
  )
}

export default OrderHistory
